module.exports = __webpack_public_path__ + "static/media/firefox developer.48752c8f.png";